import { configureStore } from '@reduxjs/toolkit';
import businessList from './businessListSlice';
import user from './userSlice';
import organization from './organizationSlice';
import map from './mapSlice';
import { firestoreApi } from './firestoreApi';
import snackbar from './snackbarSlice';

export const store = configureStore({
  reducer: {
    [firestoreApi.reducerPath]: firestoreApi.reducer,
    businessList,
    user,
    organization,
    map,
    snackbar,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(firestoreApi.middleware);
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
